var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "q-tabs",
        {
          staticClass: "shadow-1 bg-white",
          attrs: {
            color: "white",
            "text-color": "primary",
            "underline-color": "primary",
            align: "justify"
          },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "training",
              label: _vm.$t("training"),
              icon: "fas fa-graduation-cap"
            },
            slot: "title"
          }),
          _c(
            "q-tab-pane",
            {
              staticClass: "q-px-md q-pb-xl q-mt-md",
              attrs: { name: "training" }
            },
            [
              _c(
                "div",
                [
                  _vm.$q.platform.is.desktop
                    ? _c("div", { staticClass: "row gutter-sm" }, [
                        _c("div", { staticClass: "col-sm-11" }, [
                          _c("p", { staticClass: "q-title" }, [
                            _vm._v(_vm._s(_vm.title))
                          ]),
                          _c(
                            "p",
                            { staticClass: "q-body-1 text-weight-light" },
                            [_vm._v(_vm._s(_vm.description))]
                          )
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "col-sm-1 cursor-pointer",
                            on: {
                              click: function($event) {
                                return _vm.showCertificate()
                              }
                            }
                          },
                          [
                            _c(
                              "vc-donut",
                              {
                                attrs: {
                                  sections: !_vm.course.is_open
                                    ? _vm.sections
                                    : [],
                                  size: 100,
                                  unit: "%"
                                }
                              },
                              [
                                _vm.user_progress < 100 &&
                                _vm.group_training_user_result_status != 1 &&
                                _vm.group_training_user_result_status != 2 &&
                                !_vm.course.is_open
                                  ? _c("h6", { staticClass: "text-primary" }, [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.getPercentage(_vm.user_progress)
                                          ) +
                                          "%\n                                "
                                      )
                                    ])
                                  : _vm._e(),
                                _vm.user_progress == 100 ||
                                _vm.group_training_user_result_status == 1 ||
                                (_vm.group_training_user_result_status == 2 &&
                                  !_vm.course.is_open)
                                  ? _c("q-icon", {
                                      attrs: {
                                        name: _vm.getResult,
                                        color: _vm.getResultColor,
                                        size: "2rem"
                                      }
                                    })
                                  : _vm._e(),
                                _vm.course.is_open
                                  ? _c(
                                      "q-icon",
                                      {
                                        attrs: {
                                          name: "far fa-clock",
                                          color: "primary",
                                          size: "2rem"
                                        }
                                      },
                                      [
                                        _c("q-tooltip", [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                _vm.$t(
                                                  "this_course_is_being_published_your_progress_will_show_when_its_finished"
                                                )
                                              ) +
                                              "\n                                    "
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.group_training_user_result_status == 2 &&
                                !_vm.course.is_open
                                  ? _c("q-tooltip", [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.$t("you_were_reproved_in") +
                                              " " +
                                              _vm.group_training_user_result_date
                                          ) +
                                          "\n                                "
                                      )
                                    ])
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm.$q.platform.is.mobile
                    ? _c("div", { staticClass: "row gutter-xs" }, [
                        _c("div", { staticClass: "col-xs-10" }, [
                          _c("p", { staticClass: "q-title" }, [
                            _vm._v(_vm._s(_vm.title))
                          ])
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "col-xs-2",
                            on: {
                              click: function($event) {
                                return _vm.showCertificate()
                              }
                            }
                          },
                          [
                            _c(
                              "vc-donut",
                              {
                                attrs: {
                                  sections: !_vm.course.is_open
                                    ? _vm.sections
                                    : [],
                                  size: 100,
                                  unit: "%"
                                }
                              },
                              [
                                _vm.user_progress < 100 &&
                                _vm.group_training_user_result_status != 1 &&
                                _vm.group_training_user_result_status != 2
                                  ? _c("h6", { staticClass: "text-primary" }, [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.getPercentage(_vm.user_progress)
                                          ) +
                                          "%\n                                "
                                      )
                                    ])
                                  : _vm._e(),
                                _vm.user_progress == 100 ||
                                _vm.group_training_user_result_status == 1 ||
                                _vm.group_training_user_result_status == 2
                                  ? _c("q-icon", {
                                      attrs: {
                                        name: _vm.getResult,
                                        color: _vm.getResultColor,
                                        size: "1.5rem"
                                      }
                                    })
                                  : _vm._e(),
                                _vm.group_training_user_result_status == 2
                                  ? _c("q-tooltip", [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.$t("you_were_reproved_in") +
                                              " " +
                                              _vm.group_training_user_result_date
                                          ) +
                                          "\n                                "
                                      )
                                    ])
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c("div", { staticClass: "col-xs-12 col-sm-11" }, [
                          _c(
                            "p",
                            { staticClass: "q-body-1 text-weight-light" },
                            [_vm._v(_vm._s(_vm.description))]
                          )
                        ])
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "row reverse gutter-sm q-mt-sm" }, [
                    _vm.$route.name == "course"
                      ? _c(
                          "div",
                          {
                            class: _vm.$q.platform.is.ipad
                              ? "col-4"
                              : "col-xs-12 col-sm-2"
                          },
                          [
                            _c("q-btn", {
                              staticClass: "full-width",
                              attrs: {
                                label: _vm.$t("back"),
                                color: "primary",
                                icon: "fas fa-chevron-left"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.$router.push({ name: "courses" })
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$route.name == "course" && _vm.owners
                      ? _c(
                          "div",
                          {
                            class: _vm.$q.platform.is.ipad
                              ? "col-4"
                              : "col-xs-12 col-sm-2"
                          },
                          [
                            _vm.showDoubtsButton
                              ? _c("q-btn", {
                                  staticClass: "full-width",
                                  attrs: {
                                    label: _vm.$t("doubts"),
                                    color: "secondary",
                                    "icon-right": "far fa-question-circle"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.doubts_modal = true
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$route.name == "trail_course"
                      ? _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-2" },
                          [
                            _c("q-btn", {
                              staticClass: "full-width",
                              attrs: {
                                label: _vm.$t("back"),
                                color: "primary",
                                icon: "fas fa-chevron-left"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.$router.push({
                                    name: "trail",
                                    params: { id: _vm.$route.params.id_trail }
                                  })
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]),
                  _c(
                    "q-tabs",
                    {
                      staticClass: "q-mt-md",
                      attrs: {
                        color: "secondary",
                        "underline-color": "primary",
                        align: "justify"
                      },
                      model: {
                        value: _vm.tab_course,
                        callback: function($$v) {
                          _vm.tab_course = $$v
                        },
                        expression: "tab_course"
                      }
                    },
                    [
                      _c("q-tab", {
                        attrs: {
                          slot: "title",
                          name: "activities",
                          label: _vm.$q.platform.is.desktop
                            ? _vm.$t("activities") +
                              " (" +
                              _vm.qty_group_training_activities +
                              ")"
                            : "",
                          icon: "fas fa-pen"
                        },
                        slot: "title"
                      }),
                      _c("q-tab", {
                        attrs: {
                          slot: "title",
                          name: "support_materials",
                          label: _vm.$q.platform.is.desktop
                            ? _vm.$t("support_materials") +
                              " (" +
                              _vm.qty_group_training_materials +
                              ")"
                            : "",
                          icon: "fas fa-book"
                        },
                        slot: "title"
                      }),
                      _c("q-tab", {
                        attrs: {
                          slot: "title",
                          name: "reaction_test",
                          label: _vm.$q.platform.is.desktop
                            ? _vm.$t("reaction_test") +
                              " (" +
                              _vm.qty_group_training_evaluations +
                              ")"
                            : "",
                          icon: "fas fa-clipboard-check"
                        },
                        slot: "title"
                      }),
                      _vm.hasForum
                        ? _c("q-tab", {
                            attrs: {
                              slot: "title",
                              name: "discussions",
                              label: _vm.$q.platform.is.desktop
                                ? _vm.$t(_vm.moduleName) +
                                  " (" +
                                  _vm.qty_group_training_discussions +
                                  ")"
                                : "",
                              icon: "far fa-comments"
                            },
                            slot: "title"
                          })
                        : _vm._e(),
                      _c(
                        "q-tab-pane",
                        {
                          staticClass: "q-px-md q-pb-md",
                          attrs: { name: "activities" }
                        },
                        [
                          _c("activities", {
                            attrs: { course: _vm.course },
                            on: { reloadActivity: _vm.reloadActivity }
                          })
                        ],
                        1
                      ),
                      _c(
                        "q-tab-pane",
                        {
                          staticClass: "q-px-md q-pb-xl q-mt-md",
                          attrs: { name: "support_materials" }
                        },
                        [_c("support-materials")],
                        1
                      ),
                      _c(
                        "q-tab-pane",
                        {
                          staticClass: "q-px-md q-pb-xl q-mt-md",
                          attrs: { name: "reaction_test" }
                        },
                        [_c("reaction-test")],
                        1
                      ),
                      _c(
                        "q-tab-pane",
                        {
                          staticClass: "q-px-xs q-pb-lg q-mt-xs",
                          attrs: { name: "discussions" }
                        },
                        [_c("discussions")],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c(
        "q-modal",
        {
          attrs: { "content-css": { minWidth: "60vw", minHeight: "40vh" } },
          model: {
            value: _vm.doubts_modal,
            callback: function($$v) {
              _vm.doubts_modal = $$v
            },
            expression: "doubts_modal"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    directives: [
                      { name: "close-overlay", rawName: "v-close-overlay" }
                    ],
                    attrs: { flat: "", round: "", dense: "", icon: "close" }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(_vm._s(_vm.$t("doubts").toUpperCase() + "?"))
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "row q-ma-md", staticStyle: { width: "90%" } },
                [
                  _c(
                    "div",
                    { staticClass: "q-ma-sm col-xs-12 col-sm-6" },
                    [
                      _c("q-input", {
                        attrs: {
                          "float-label": _vm.$t("name"),
                          error: _vm.$v.name.$error,
                          disable: _vm.block_fields
                        },
                        on: { input: _vm.$v.name.$touch },
                        model: {
                          value: _vm.name,
                          callback: function($$v) {
                            _vm.name = $$v
                          },
                          expression: "name"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "q-ma-sm col-12" },
                    [
                      _c("q-input", {
                        attrs: {
                          type: "email",
                          "float-label": _vm.$t("email"),
                          error: _vm.$v.email.$error,
                          disable: _vm.block_fields
                        },
                        on: { input: _vm.$v.email.$touch },
                        model: {
                          value: _vm.email,
                          callback: function($$v) {
                            _vm.email = $$v
                          },
                          expression: "email"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "q-mx-sm q-mt-sm q-mb-xs col-12" },
                    [
                      _c("q-input", {
                        attrs: {
                          "float-label": _vm.$t("doubts_about_training"),
                          error: _vm.$v.email.$error,
                          disable: ""
                        },
                        on: { input: _vm.$v.email.$touch },
                        model: {
                          value: _vm.title,
                          callback: function($$v) {
                            _vm.title = $$v
                          },
                          expression: "title"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "q-mb-md q-mx-sm q-pt-xs col-12" },
                    [
                      _c("q-input", {
                        attrs: {
                          type: "textarea",
                          rows: "5",
                          "float-label": _vm.$t("message"),
                          error: _vm.$v.message.$error
                        },
                        on: { input: _vm.$v.message.$touch },
                        model: {
                          value: _vm.message,
                          callback: function($$v) {
                            _vm.message = $$v
                          },
                          expression: "message"
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _c(
                "q-toolbar",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c("q-btn", {
                    staticClass: "q-mx-sm",
                    attrs: { color: "positive", label: _vm.$t("send") },
                    on: { click: _vm.askQuestion }
                  }),
                  _c("q-btn", {
                    staticClass: "q-mx-sm",
                    attrs: { color: "negative", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.doubts_modal = false
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("certificate", {
        attrs: {
          show: _vm.show_certificate,
          data: _vm.certificate_data,
          certificate: _vm.certificate
        },
        on: { hideCertificate: _vm.hideCertificate }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }